import { Location } from 'history';
import AppState from '../state';

export const showMainLoader = (state: AppState) => {
  return !!Object.entries(state.ui.loading).filter(
    ([_, type]) => type === 'main'
  ).length;
};

export const isDifferentBgColor = (location: Location) => {
  return (
    location.pathname.startsWith('/dashboard') ||
    location.pathname.startsWith('/earnings') ||
    location.pathname.startsWith('/release') ||
    location.pathname.startsWith('/artist-selector') ||
    location.pathname.startsWith('/artist') ||
    location.pathname.startsWith('/user') ||
    location.pathname.startsWith('/release-subscription-plan') ||
    location.pathname.startsWith('/catalog') ||
    location.pathname.startsWith('/notifications') ||
    location.pathname.startsWith('/analytics') ||
    location.pathname.startsWith('/terms-of-service') ||
    location.pathname.startsWith('/privacy-policy') ||
    location.pathname.startsWith('/plans') ||
    location.pathname.startsWith('/payment') ||
    location.pathname.startsWith('/close-account') ||
    location.pathname.startsWith('/2fa') ||
    location.pathname.startsWith('/password-2fa') ||
    location.pathname.startsWith('/alpha-pilot-user-agreement')
  );
};

export const hasFlexEnd = (location: Location) => {
  return (
    location.pathname.startsWith('/release') ||
    location.pathname.startsWith('/music-video') ||
    location.pathname.startsWith('/merch') ||
    location.pathname.endsWith('/upgrade-release')
  );
};

export const isDifferentHeaderColor = (location: Location) => {
  return (
    location.pathname.startsWith('/release') ||
    location.pathname.startsWith('/merch') ||
    location.pathname.startsWith('/tracpage') ||
    location.pathname.startsWith('/user') ||
    location.pathname.startsWith('/login') ||
    location.pathname.startsWith('/register') ||
    location.pathname.startsWith('/merch') ||
    location.pathname.startsWith('/takedown-release') ||
    location.pathname.startsWith('/correct-profile') ||
    location.pathname.startsWith('/upgrade-release') ||
    location.pathname.startsWith('/artist') ||
    location.pathname.startsWith('/label')
  );
};
